import { SIZE } from 'baseui/select';
export const SUPPORTED_URL_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'sms:', 'tel:']);

// Source: https://stackoverflow.com/a/8234912/2013580
export const urlRegExp = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/);
export const SELECT_PROPS = {
  size: SIZE.mini,
  searchable: false,
  clearable: false,
  overrides: {
    DropdownContainer: {
      style: () => ({
        display: 'flex',
        flexDirectiion: 'column',
        width: '100%'
      })
    },
    Root: {
      style: () => ({
        width: 'auto'
      })
    }
  }
};